/*
 * @Author: zhengshuhua
 * @Date: 2021-09-14 09:24:25
 * @LastEditors: zhangquanming 419654548@qq.com
 * @LastEditTime: 2024-01-08 16:28:31
 * @Description: file content
 * @FilePath: \edc-mobile-web\src\local\getter.js
 */
import state from './state'
import localApi from './localapi'
const getter = {
	getCenterCode() {
		return localApi.getLocal(state.centerCode)
	},
	getNetworkFlag() {
		const info = localApi.getLocal(state.networkFlag)
		return info ? JSON.parse(info) : false
	},
	getResearchCode() {
		return localApi.getLocal(state.researchCode) || ''
	},
	getRouteMoreRecord() {
		const info = localApi.getLocal(state.routeMoreRecord)
		return info ? JSON.parse(info) : null
	},
	getUserInfo() {
		const info = localApi.getLocal(state.userInfo)
		return info ? JSON.parse(info) : null
	},
	getUserToken() {
		return localApi.getLocal(state.userToken) || ''
	},
	getUserAuthority() {
		const info = localApi.getLocal(state.userAuthority)
		return info ? JSON.parse(info) : []
	},
	getIdentityType() {
		return Number(localApi.getSession(state.identityType)) || 1
	},
	getUserOpenId() {
		return localApi.getLocal(state.userOpenId) || ''
	},
	getTesteeScrollTop() {
		return localApi.getSession(state.testeeScrollTop) || 0
	},
	getResearchScrollTop() {
		return localApi.getSession(state.researchScrollTop) || 0
	},
	getTesteePaginationConfig() {
		const info = localApi.getLocal(state.testeePaginationConfig)
		return info ? JSON.parse(info) : null
	},
	getRecruitPaginationConfig() {
		const info = localApi.getLocal(state.recruitPaginationConfig)
		return info ? JSON.parse(info) : null
	}
}
export default getter
